import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { browserHistory } from 'react-router';
import { withFetch } from '@flowio/redux-fetch';
import { fetchOrganization, getBaseOrganizationCurrency } from '../../../../organization';
import { fetchExperience, getMargin } from '../../../actions';
import ItemMarginEdit from '../components/item-margin-edit';
import { getMarginErrors, getMarginByKey } from '../../../selectors';
import { StateProps, OwnProps, DispatchProps } from '../types';
import { RootState, ThunkDispatcher } from '../../../../../stores/types';

function getAsyncState(
  dispatch: ThunkDispatcher,
  _getState: () => RootState,
  ownProps: OwnProps,
): Promise<unknown[]> {
  const { organization, experienceKey, marginKey } = ownProps.params;
  return Promise.all([
    dispatch(fetchOrganization(organization)),
    dispatch(fetchExperience(organization, experienceKey)),
    dispatch(getMargin(organization, experienceKey, marginKey)),
  ]);
}

const mapStateToProps: MapStateToProps<StateProps, OwnProps, RootState> = (state, { params }) => ({
  itemMargin: getMarginByKey(params.marginKey)(state),
  currency: getBaseOrganizationCurrency(state),
  errors: getMarginErrors(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (_dispatch, ownProps) => {
  const { organization, experienceKey } = ownProps.params;

  return {
    onCancel(): void {
      browserHistory.push(`/${organization}/experience/${experienceKey}/pricing`);
    },
  };
};

export default withFetch(getAsyncState)(
  connect(mapStateToProps, mapDispatchToProps)(ItemMarginEdit),
);
